import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { QB_DRAG_TYPES, QB_GROUP_CONDITION_TYPES, QB_FIELD_SHARED_ACTIONS } from './types.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * this is injected. instance of QBStore
 *
 * @param {*} idGroup: UUID
 * @param idGroup
 */

var createNewFilter = function createNewFilter(idGroup) {
  var idFilter = "filter_".concat(new Date().getTime(), "_").concat(Math.random().toString(36).substring(7));
  return {
    idGroup: idGroup,
    field: '',
    condition: '',
    value: '',
    idFilter: idFilter,
    type: QB_DRAG_TYPES.FILTER
  };
};
/**
 * this is injected. instance of QBStore
 *
 * @param {*} parentIdGroup: UUID
 * @param parentIdGroup
 */

var createNewGroup = function createNewGroup(parentIdGroup) {
  var idGroup = "group_".concat(new Date().getTime(), "_").concat(Math.random().toString(36).substring(7));
  return {
    parentIdGroup: parentIdGroup,
    idGroup: idGroup,
    condition: QB_GROUP_CONDITION_TYPES.AND,
    type: QB_DRAG_TYPES.GROUP
  };
};
/**
 * this is injected. instance of QBStore
 *
 * @param {*} newFilter
 */

var addFilterToMap = function addFilterToMap(newFilter) {
  this.mapFilters = _objectSpread(_objectSpread({}, this.mapFilters), {}, _defineProperty({}, newFilter.idFilter, newFilter));
};
/**
 * this is injected. instance of QBStore
 *
 * @param {*} newFilter
 * @param newGroup
 */

var addGroupToMap = function addGroupToMap(newGroup) {
  this.mapGroups = _objectSpread(_objectSpread({}, this.mapGroups), {}, _defineProperty({}, newGroup.idGroup, _objectSpread({}, newGroup)));
};
var addFilterToItem = function addFilterToItem(item, newFilter) {
  item.children.push({
    id: newFilter.idFilter,
    element: newFilter,
    children: []
  });
};
var addFilterToMainItem = function addFilterToMainItem(items, newFilter) {
  items.push({
    id: newFilter.idFilter,
    element: newFilter,
    children: []
  });
};
var findInChilds = function findInChilds(childs, filterId) {
  var found = childs.find(function (_ref) {
    var id = _ref.id;
    return id === filterId;
  });

  if (!found) {
    var findInChild;
    childs.forEach(function (item) {
      if (!findInChild) findInChild = findInChilds(item.children, filterId);
    });
    if (findInChild) return findInChild;
  }

  return found;
};
var findItemFilterById = function findItemFilterById(filterId) {
  return findInChilds(this.items, filterId);
};
var findParentWithFilterId = function findParentWithFilterId(childs, filterId) {
  var found = childs.find(function (_ref2) {
    var id = _ref2.id;
    return id === filterId;
  });

  if (!found) {
    var findInChild;
    childs.forEach(function (item) {
      if (!findInChild) findInChild = findParentWithFilterId(item.children, filterId);
    });
    if (findInChild) return findInChild;
  }

  return childs;
};
var findParentFilterById = function findParentFilterById(filterId) {
  return findParentWithFilterId(this.items, filterId);
};
var filterInChildren = function filterInChildren(childs, filterId, mainId) {
  if (childs.children) {
    childs.children = childs.children.filter(function (_ref3) {
      var id = _ref3.id;
      return id !== filterId;
    });
    childs.children = childs.children.forEach(function (item) {
      return filterInChildren(item.children, filterId);
    });
    return childs;
  } // main


  if (childs.length > 1) childs = childs.filter(function (_ref4) {
    var id = _ref4.id;
    return id !== filterId;
  }); // https://jira.elliemae.io/browse/PUI-1252

  if (childs.length === 0 && mainId) {
    var emptyFilter = createNewFilter.call(this, mainId);
    addFilterToMainItem.call(this, childs, emptyFilter);
  }

  childs.forEach(function (item) {
    return item.children = filterInChildren(item.children, filterId);
  });
  return childs;
};
var removeFilterItem = function removeFilterItem(filterId) {
  this.items = filterInChildren(this.items, filterId, this.main);
};
var addGroupFilterToItem = function addGroupFilterToItem(idGroup, idFilter, newGroup) {
  var child = findItemFilterById.call(this, idFilter);

  var copy = _objectSpread({}, child);

  if (copy.element.type === 'group') {
    copy.element.parentIdGroup = newGroup.idGroup;
  } else {
    copy.element.idGroup = newGroup.idGroup;
  }

  child.id = newGroup.idGroup;
  child.element = newGroup;
  child.children = [copy];
};
var unGroupFilterToItem = function unGroupFilterToItem(idGroup) {
  var _this = this;

  var group = findItemFilterById.call(this, idGroup);

  if (group.element.parentIdGroup === this.main) {
    var index = this.items.map(function (item) {
      return item.id;
    }).indexOf(idGroup);
    var tmp = [];
    tmp.splice.apply(this.items, [index, 1].concat(group.children));
    this.items.forEach(function (item) {
      if (item.element.type === 'group') {
        item.element.parentIdGroup = _this.main;
      } else {
        item.element.idGroup = _this.main;
      }
    });
  } else {
    var parent = findItemFilterById.call(this, group.element.parentIdGroup);

    var _index = parent.children.map(function (item) {
      return item.id;
    }).indexOf(idGroup);

    var _tmp = [];

    _tmp.splice.apply(parent.children, [_index, 1].concat(group.children));

    parent.children.forEach(function (item) {
      if (item.element.type === 'group') {
        item.element.parentIdGroup = parent.id;
      } else {
        item.element.idGroup = parent.id;
      }
    });
  }
};
var changeGroupOperator = function changeGroupOperator(idGroup, value) {
  var group = findItemFilterById.call(this, idGroup);

  if (idGroup !== this.main) {
    group.element.condition = value;
  }
};
var changeFilterItem = function changeFilterItem(_ref5) {
  var idFilter = _ref5.idFilter,
      field = _ref5.field,
      value = _ref5.value,
      operator = _ref5.operator,
      additionalInfo = _ref5.additionalInfo,
      target = _ref5.target,
      _ref5$fieldsSharedAct = _ref5.fieldsSharedActions,
      onFieldChange = _ref5$fieldsSharedAct.onFieldChange,
      onOperatorChange = _ref5$fieldsSharedAct.onOperatorChange,
      onValueChange = _ref5$fieldsSharedAct.onValueChange;
  var child = findItemFilterById.call(this, idFilter);
  if (field || field === '' || typeof field === 'boolean') child.element.field = field;
  if (operator) child.element.operator = operator;
  if (value || value === '' || typeof value === 'boolean') child.element.value = value;
  if (additionalInfo) child.element.additionalInfo = additionalInfo; // shared fields actions

  if (target === 'field') {
    onFieldChange.forEach(function (_ref6) {
      var action = _ref6.action;
      if (action === QB_FIELD_SHARED_ACTIONS.RESET_FIELD) child.element.field = null;else if (action === QB_FIELD_SHARED_ACTIONS.RESET_OPERATOR) child.element.operator = null;else if (action === QB_FIELD_SHARED_ACTIONS.RESET_VALUE) child.element.value = null;
    });
  } else if (target === 'operator') {
    onOperatorChange.forEach(function (_ref7) {
      var action = _ref7.action;
      if (action === QB_FIELD_SHARED_ACTIONS.RESET_FIELD) child.element.field = null;else if (action === QB_FIELD_SHARED_ACTIONS.RESET_OPERATOR) child.element.operator = null;else if (action === QB_FIELD_SHARED_ACTIONS.RESET_VALUE) child.element.value = null;
    });
  } else if (target === 'value') {
    onValueChange.forEach(function (_ref8) {
      var action = _ref8.action;
      if (action === QB_FIELD_SHARED_ACTIONS.RESET_FIELD) child.element.field = null;else if (action === QB_FIELD_SHARED_ACTIONS.RESET_OPERATOR) child.element.operator = null;else if (action === QB_FIELD_SHARED_ACTIONS.RESET_VALUE) child.element.value = null;
    });
  }
};

export { addFilterToItem, addFilterToMainItem, addFilterToMap, addGroupFilterToItem, addGroupToMap, changeFilterItem, changeGroupOperator, createNewFilter, createNewGroup, filterInChildren, findInChilds, findItemFilterById, findParentFilterById, findParentWithFilterId, removeFilterItem, unGroupFilterToItem };
//# sourceMappingURL=actions.js.map
